import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Atestados do paciente, com cache de leitura offline (via useCachedQuery).
export function useAttesteds(patientId) {
  const url = patientId ? `/patients/${patientId}/attesteds` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    attesteds: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
